import { TerritoryMapFiltersModels } from 'src/app/models/territory-map/territory-map-filters.model';
import { TerritoryMapStoreModels } from './territoryMapData.state';

export function getTerritoryMapStoredData(territoryMap: TerritoryMapStoreModels[], reportType: string, addedFilters: TerritoryMapFiltersModels){

    let results: {data: TerritoryMapStoreModels|null, index: number} = {
        data: null,
        index: -1
    }

    const index = territoryMap.findIndex(data=>data.reportType==reportType &&
        data.addedFilters.accountChannelId==addedFilters.accountChannelId &&
        data.addedFilters.selectedTerritoryId==addedFilters.selectedTerritoryId);

    if(index > -1){
        results.data = territoryMap[index];
        results.index = index;
    }

    return results;

}
